import React from 'react';
import './App.css';

export default function App() {
  return (
    <div className="shutdown-page">
      <div className="shutdown-card">
        <h1>WeightSync has closed down</h1>
        <p>
          Thanks to everyone who used WeightSync to sync their weight data
          between Fitbit, Garmin, Strava, Wahoo and Runalyze.
        </p>
        <p>
          The site is no longer running. Google is retiring the Fitbit API,
          and keeping WeightSync going without it isn&apos;t something I have
          time for right now.
        </p>
        <p>
          It may come back one day after migrating to the Google Health
          Connect API, but that&apos;s not on the cards for the moment.
        </p>
        <p>
          Any questions can be directed to{' '}
          <a href="mailto:admin@weightsync.org">admin@weightsync.org</a>.
        </p>
        <p>
          Thanks for your support — Simon
        </p>
      </div>
    </div>
  );
}
